import React, { Fragment, useState, useCallback, useEffect,
Suspense } from 'react';
import openSocket from 'socket.io-client';
import './App.css';
import { Route, Switch } from 'react-router-dom';
import Header from './shared/components/header/header';
import { AuthContext } from './shared/context/auth-context';
import ErrorModal from './shared/components/UIElements/ErrorModal';
import EditExp from './pages/editExp';
import Modal from './shared/components/UIElements/modal';
import { connect } from 'react-redux';
import { closeEditExp } from './redux/editExp/editExp-actions';
import { addNewNoti, getNotiCount } from './redux/notifications/notifications-actions';
import { FadeLoader } from 'react-spinners';

const ExpsByCountryPage = React.lazy(() => import('./pages/expsByCountryPage'));
const ShowExpPage = React.lazy(() => import('./pages/showExpPage'));
const ProfilePage = React.lazy(() => import('./pages/profilePage'));
const HomePage = React.lazy(() => import('./pages/homePage'));
const ErrorPage = React.lazy(() => import('./pages/errorPage'));
const SignPage = React.lazy(() => import('./pages/signPage'));
const SignupPage = React.lazy(() => import('./pages/signupPage'));



const App = props => {
  const [token, setToken] = useState(false);
  const [user, setUser] = useState(false);

  const login = useCallback((token, user) => {
    setUser(user);
    setToken(token);

    localStorage.setItem('userData',
      JSON.stringify({ token, user })
    );

    const socket = openSocket(process.env.REACT_APP_BACKEND_URL);
    socket.emit('new-user', user._id.toString())
    socket.on('noti', socket => {
      props.addNewNoti(socket.payload)
    });


  }, []);
  

  const logout = useCallback(() => {
    setUser(null);
    setToken(null);

    localStorage.removeItem('userData');
    setTimeout(() => {
      window.location.reload(false)

    }, 200)

  }, []);
  
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (storedData && storedData.token) {
      login(storedData.token, storedData.user)
    }

    
  }, [login]);
  

  let routes;
  
  if (token) {
    routes = (
      <Fragment>
        <Header /> 
        <Switch>
          <Route exact path='/:userId/coun/:counname' component={ExpsByCountryPage} />
          <Route exact path='/exp/:expId' component={ShowExpPage} />
          <Route exact path='/p/:userId' component={ProfilePage} />
          <Route exact path='/' component={HomePage} /> 
          <Route path='*' component={ErrorPage} />
        </Switch>
        <Modal className='mod' 
        show={props.editExpIsOpen} onCancel={props.closeEditExp}
        animation={`animate__animated animate__slideInUp
        ${!props.editExpIsOpen && 'animate__slideOutDown'}`}
        exit='700'
        style={{animationDuration: '0.4s', minWidth: '410px' }} > 
          <EditExp />
        </Modal>
        <Modal className='modal-error'
        error
        show={true} onCancel={() => {}}
        animation='animate__animated animate__slideInUp'
        style={{animationDuration: '0.4s'}} >
          <ErrorModal />
        </Modal>
      </Fragment>
    )
  } else {
    routes = (
      <Fragment> 
        <Switch>
          <Route exact path='/' component={SignPage} />
          <Route exact path='/signup' component={SignupPage} />
          <Route path='*' component={ErrorPage} />
        </Switch>
        <Modal className='modal-error'
        error
        show={true} onCancel={() => {}}
        animation='animate__animated animate__slideInUp'
        style={{animationDuration: '0.4s'}} >
          <ErrorModal />
        </Modal>
      </Fragment>
    )
  }


  return (
    <AuthContext.Provider
    value={{isLoggedIn: !!token, login, logout, token, user }}>
      <main>
        <Suspense fallback={<div className='center'><FadeLoader margin={2}
        height={15} width={5} radius={2} /></div>} >
          {routes}
        </Suspense>
      </main>
    </AuthContext.Provider>
  );
}


const mapStateToProps = state => ({
  editExpIsOpen: state.editExp.editExpIsOpen
});

export default connect(mapStateToProps, { closeEditExp, addNewNoti, getNotiCount })(App);
